import { css, cx } from "@linaria/core";
import { useRef } from "react";

import type { Pagination } from "./hook.pagination";
import * as styles from "./item.style";

const sliderItemCls = css``;
export const sliderItemSelector = `.${sliderItemCls}`;

type Props<T> = {
  sliderRef: React.RefObject<HTMLUListElement | null>;
  item: T & { index: number };
  disabled: boolean;
  infinite: boolean;
  pagination: Pagination;
  children(
    item: T,
    extra: {
      index: number;
      isVisible: boolean;
      location: "left" | "right" | "center";
      disabled: boolean;
    },
  ): React.JSX.Element;
};

export function SliderItem<T>(props: Props<T>): React.JSX.Element {
  const ref = useRef<HTMLLIElement>(null);

  const isAtLeftEdge = props.infinite
    ? props.item.index % props.pagination.itemsPerPage === 0
    : props.pagination.activeItemIndex - props.item.index > 0;
  const isAtRightEdge = props.infinite
    ? props.item.index % props.pagination.itemsPerPage ===
      props.pagination.itemsPerPage - 1
    : props.pagination.activeItemIndex - props.item.index < 0;

  const isVisible =
    props.item.index >=
      props.pagination.activeItemIndex -
        (props.pagination.itemsPerPage - 1) / 2 &&
    props.item.index <=
      props.pagination.activeItemIndex +
        (props.pagination.itemsPerPage - 1) / 2;

  return (
    <li
      ref={ref}
      className={cx(styles.item, !props.disabled && sliderItemCls)}
      data-left={isAtLeftEdge}
      data-right={isAtRightEdge}
      data-center={!isAtLeftEdge && !isAtRightEdge}
    >
      {props.children(props.item, {
        index: props.item.index,
        disabled: props.disabled,
        isVisible,
        location: isAtLeftEdge ? "left" : isAtRightEdge ? "right" : "center",
      })}
    </li>
  );
}
